// extracted by mini-css-extract-plugin
export default {"button":"Button_button__s88xk","long":"Button_long__IS1dN","light":"Button_light__i1Pdb"};